import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import {useAuth} from "../../context/AuthContext";
import {ROUTES} from "../../constants/routes";

interface Props {
    children: ReactNode;
    permissions?: any[];
}

export const PrivateRoute = ({ children, permissions }: Props) => {
    const { loading, user } = useAuth();
    if (loading){
        return(<div>Отоборажение загрузки</div>);
    }
    if(!user?.accessToken){
        return <Navigate to={`${ROUTES.LOGIN.path}`}/>;
    }
    return(
        permissions?.some(x=> user.rights.includes(x)) ? <>{children}</> : <Navigate to={`${ROUTES.NOT_ALLOWED.path}`} />
    );
};